import { useAuth } from '@/hooks/useAuth';

export function LoginPage() {
    const { login, isLoading, error } = useAuth();

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
            {/* Background decoration */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 -left-32 w-96 h-96 bg-ocean-500/5 rounded-full blur-3xl" />
                <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />
            </div>

            <div className="relative w-full max-w-sm">
                {/* Logo */}
                <div className="flex flex-col items-center mb-8">
                    <img
                        src="/aipeces-mark-dark-ui.png"
                        alt="AiPeces"
                        className="w-16 h-16 rounded-2xl mb-4 shadow-lg shadow-ocean-500/20 object-contain"
                    />
                    <h1 className="text-2xl font-bold text-foreground tracking-tight">AiPeces Admin</h1>
                    <p className="text-sm text-muted-foreground mt-1">Panel de Administración</p>
                </div>

                {/* Login Card */}
                <div className="rounded-2xl border border-border bg-card p-8 shadow-xl shadow-black/10">
                    <div className="text-center mb-6">
                        <h2 className="text-lg font-semibold text-foreground">Iniciar sesión</h2>
                        <p className="text-sm text-muted-foreground mt-1">
                            Accede con tu cuenta de administrador
                        </p>
                    </div>

                    {error && (
                        <div className="mb-4 p-3 rounded-lg bg-destructive/10 border border-destructive/20 text-destructive text-sm text-center">
                            {error}
                        </div>
                    )}

                    <button
                        onClick={login}
                        disabled={isLoading}
                        className="w-full flex items-center justify-center gap-3 h-12 px-6 rounded-xl font-medium text-sm bg-white text-zinc-800 hover:bg-zinc-100 disabled:opacity-50 transition-colors shadow-sm"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z" fill="#4285F4" />
                            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23Z" fill="#34A853" />
                            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62Z" fill="#FBBC05" />
                            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53Z" fill="#EA4335" />
                        </svg>
                        {isLoading ? 'Conectando...' : 'Continuar con Google'}
                    </button>

                    <p className="text-center text-[11px] text-muted-foreground mt-4">
                        Solo cuentas de administrador autorizadas
                    </p>
                </div>

                {/* Footer */}
                <p className="text-center text-[11px] text-muted-foreground mt-6">
                    AiPeces © {new Date().getFullYear()} — Panel de Administración
                </p>
            </div>
        </div>
    );
}
